import { render, staticRenderFns } from "./_HistoryRow.vue?vue&type=template&id=70c143b9"
import script from "./_HistoryRow.vue?vue&type=script&lang=js"
export * from "./_HistoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports